import type { FlowEdge, FlowNode } from '@lighthouse/shared'
import { useEdgesState, useReactFlow, useStore } from '@xyflow/react'
import React, { memo } from 'react'

import { FlowProvider } from '@/contexts/FlowContext'

// import WorkflowManager from '@/store/workflow/WorkflowManager'
import { Flow } from './components/Flow'

interface FlowDetailContentProps {}

const FlowDetailContent: React.FC<FlowDetailContentProps> = () => {
    const { getEdges, setNodes } = useReactFlow<FlowNode, FlowEdge>()
    const { nodes } = useStore(state => ({
        nodes: state.nodes as FlowNode[]
    }))

    const [flowEdges, setEdges] = useEdgesState(getEdges())

    return (
        <FlowProvider nodes={nodes} edges={flowEdges} setNodes={setNodes} setEdges={setEdges}>
            <Flow />
        </FlowProvider>
    )
}

export default memo(FlowDetailContent)
